/* eslint-disable */
import React, { Component } from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/brand/nautilusshipping.jpeg";
import { hasPermission } from "../Settings/Settings"
var mneuList = [
  {
    moduleID:1,
    name: "Dashboard",
    icon: "fe fe-home",
    link: "dashboard",
    active: ["dashboard"]
  },
  {
    moduleID:2,
    name: "Client",
    icon: "fa fa-building-o",
    link: "owner",
    active: ["company"]
  },
  {
    moduleID:3,
    name: "Vessel Type",
    icon: "fa fa-ship",
    link: "vesseltype",
    active: ["vesseltype"]
  }, 
  {
    moduleID:4,
    name: "Vessel",
    icon: "fa fa-ship",
    link: "vessel",
    active: ["vessel"]
  },
  {
    moduleID:31,
    name: "Vessel Position",
    icon: "fa fa-ship",
    link: "vesselposition",
    active: ["vesselposition"]
  },
  {
    moduleID:47,
    name: "Crew Planner",
    icon: "fa fa-calendar-check-o",
    link: "crewplanner",
    active: ["crewplanner"]
  },

  {
    moduleID:5,
    name: "Experience",
    icon: "fa fa-book",
    link: "experience",
    active: ["experience"]
  },
  {
    moduleID:6,
    name: "Rank",
    icon: "fa fa-random",
    link: "rank",
    active: ["rank"]
  },
  {
    moduleID:7,
    name: "Grade",
    icon: "fa fa-book",
    link: "grade",
    active: ["grade"]
  },
  {
    moduleID:8,
    name: "Port",
    icon: "fa fa-map-marker",
    link: "port",
    active: ["port"]
  },
  {
    moduleID:9,
    name: "Port Agent",
    icon: "fa fa-map-marker",
    link: "portagent",
    active: ["portagent"]
  },
  {
    moduleID:10,
    name: "Hospital",
    icon: "fa fa-hospital-o",
    link: "hospital",
    active: ["hospital"]
  },
  {
    moduleID:11,
    name: "Document Type",
    icon: "fa fa-file-text-o",
    link: "documenttype",
    active: ["documenttype"]
  },
  {
    moduleID:30,
    name: "Vendor",
    icon: "fe fe-user",
    link: "vendor",
    active: ["vendor"]
  },
  {
    moduleID:18,
    name: "Branch",
    icon: "fa fa-sitemap",
    link: "branch",
    active: ["branch"]
  },
  {
    moduleID:13,
    name: "Candidate",
    icon: "fa fa-id-card",
    link: "candidate",
    active: ["candidate"]
  },
  {
    moduleID:0,
    name: "Search",
    icon: "fa fa-search",
    link: "search",
    active: ["search"]
  },
  {
    moduleID:14,
    name: "Reports",
    icon: "fa fa-bar-chart",
    link: "reports",
    active: ["reports"]
  },
  {
    moduleID:17,
    name: "PO Vendor",
    icon: "fe fe-user",
    link: "povendor",
    active: ["povendor"]
  },
  {
    moduleID:16,
    name: "Purchase Order",
    icon: "fa fa-shopping-cart",
    link: "purchaseorder",
    active: ["purchaseorder"]
  },
  {
    moduleID:32,
    name: "Portage Bill",
    icon: "fa fa-money",
    link: "portagebill",
    active: ["portagebill"]
  },
  {
    moduleID:33,
    name: "Office Document",
    icon: "fa fa-file-text-o",
    link: "officedocument",
    active: ["officedocument"]
  },
  {
    moduleID:28,
    name: "User Role",
    icon: "fa fa-shield",
    link: "role",
    active: ["role"]
  },
  {
    moduleID:29,
    name: "Users",
    icon: "fa fa-user",
    link: "users",
    active: ["users"]
  },
  /* {
    // No single moduleID gates this row - see render(): a submenu item is
    // shown for the "HRMS" parent as soon as the viewer has "view" on ANY
    // one of its children's own moduleIDs below (34-46 per
    // /userrole/getModuleList), and only the permitted children render.
    name: "HRMS",
    icon: "fa fa-users",
    link: "",
    active: ["employee", "designation", "department", "skill", "language", "industry", "staffcategory", "modeofentry", "identity", "city", "doctype", "hrms-branch", "hrms-company"],
    submenu: [
      { moduleID: 34, name: "Employee", link: "hrms/employee", active: "employee" },
      { moduleID: 41, name: "HRMS Company", link: "hrms/company", active: "hrms-company" },
      { moduleID: 42, name: "HRMS Branch", link: "hrms/branch", active: "hrms-branch" },
      { moduleID: 35, name: "Designation", link: "hrms/designation", active: "designation" },
      { moduleID: 36, name: "Department", link: "hrms/department", active: "department" },
      { moduleID: 37, name: "Skill", link: "hrms/skill", active: "skill" },
      { moduleID: 38, name: "Language", link: "hrms/language", active: "language" },
      { moduleID: 39, name: "Industry / Business", link: "hrms/industry", active: "industry" },
      { moduleID: 40, name: "Staff Category", link: "hrms/staffcategory", active: "staffcategory" },
      { moduleID: 43, name: "Mode Of Entry", link: "hrms/modeofentry", active: "modeofentry" },
      { moduleID: 44, name: "Identity", link: "hrms/identity", active: "identity" },
      { moduleID: 45, name: "City", link: "hrms/city", active: "city" },
      { moduleID: 46, name: "HRMS Document Type", link: "hrms/doctype", active: "doctype" },
    ]
  } */
];

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.sidebarRef = React.createRef();
    this.thumbRef = React.createRef();
    this.trackRef = React.createRef();
    this.menuContentRef = React.createRef();
    this.dragging = false;
    // Bound in the constructor (not componentDidMount) - render() runs first
    // and captures whatever this.handleThumbMouseDown IS AT THAT POINT for the
    // onMouseDown prop; binding later only updates the property on `this`, not
    // the reference already handed to the JSX, so the thumb's first click would
    // still invoke the unbound method (`this` undefined inside it) otherwise.
    this.updateThumb = this.updateThumb.bind(this);
    this.handleThumbMouseDown = this.handleThumbMouseDown.bind(this);
    this.handleDragMouseMove = this.handleDragMouseMove.bind(this);
    this.handleDragMouseUp = this.handleDragMouseUp.bind(this);
  }
  componentDidMount() {
    const script = document.createElement("script");
    script.src = "/assets/plugins/sidemenu/sidemenu.js";
    script.async = true;
    document.body.appendChild(script);

    const script2 = document.createElement("script");
    script2.src = "/assets/plugins/p-scroll/pscroll.js";
    script2.async = true;
    document.body.appendChild(script2);

    const script3 = document.createElement("script");
    script3.src = "/assets/js/custom.js";
    script3.async = true;
    document.body.appendChild(script3);

    // Custom sidebar scrollbar: the browser's native scrollbar thumb can't be
    // dragged reliably once `zoom` (see style.css body rule) is active, because
    // the mouse position (visual px) and the sidebar's own scrollTop/scrollHeight
    // (logical, pre-zoom px) end up in different coordinate spaces. This thumb
    // does the drag math itself using getBoundingClientRect() (visual px) so it
    // stays correct at any zoom level; wheel/trackpad scrolling is untouched and
    // still uses the native overflow-y:auto on .app-sidebar.
    const sidebar = this.sidebarRef.current;
    if (sidebar) {
      sidebar.addEventListener("scroll", this.updateThumb);
      window.addEventListener("resize", this.updateThumb);
      if (typeof ResizeObserver !== "undefined") {
        this.resizeObserver = new ResizeObserver(this.updateThumb);
        this.resizeObserver.observe(sidebar);
        // Submenus expand/collapse (jQuery slideDown/slideUp from sidemenu.js)
        // without changing .app-sidebar's own box size, only its scrollHeight -
        // observe the menu list itself so the thumb updates when that happens.
        if (this.menuContentRef.current) {
          this.resizeObserver.observe(this.menuContentRef.current);
        }
      }
      // On narrow/mobile widths, sidemenu.js/custom.js slide the sidebar
      // on/off screen by toggling classes on <body> (sidebar-gone,
      // sidebar-show, sidenav-toggled...) rather than resizing it - a
      // ResizeObserver never fires for that, so watch body's class
      // attribute directly and recompute whenever it changes. .app-sidebar
      // itself animates that slide (`transition: left, width` in style.css),
      // so the class-change instant still has the OLD (e.g. off-canvas)
      // position - a transitionend listener catches most of that, but timing
      // between the class landing and the transition actually starting is
      // browser/load-dependent, so also re-check a few times on a plain
      // timer as a fallback net regardless of whether either event fired.
      const recheckThumb = () => {
        this.updateThumb();
        [50, 150, 300, 500, 800].forEach((ms) => setTimeout(this.updateThumb, ms));
      };
      this.bodyClassObserver = new MutationObserver(recheckThumb);
      this.bodyClassObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] });
      sidebar.addEventListener("transitionend", this.updateThumb);
      this.updateThumb();
    }
  }
  componentWillUnmount() {
    const sidebar = this.sidebarRef.current;
    if (sidebar) {
      sidebar.removeEventListener("scroll", this.updateThumb);
      sidebar.removeEventListener("transitionend", this.updateThumb);
    }
    window.removeEventListener("resize", this.updateThumb);
    document.removeEventListener("mousemove", this.handleDragMouseMove);
    document.removeEventListener("mouseup", this.handleDragMouseUp);
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.bodyClassObserver) {
      this.bodyClassObserver.disconnect();
    }
  }
  updateThumb() {
    const sidebar = this.sidebarRef.current;
    const thumb = this.thumbRef.current;
    const track = this.trackRef.current;
    if (!sidebar || !thumb || !track) return;

    // getBoundingClientRect() reports real/visual px. track and thumb sit
    // inside body{zoom:0.8} (see style.css) same as everything else, so a
    // plain inline-style px value written here gets zoomed AGAIN on top of
    // that when the browser paints it (visual = logical * zoom) - dividing
    // every value by the zoom factor before assigning it cancels that out,
    // landing the track/thumb exactly on the visual pixels measured below.
    // (This is separate from the drag math in handleDragMouseMove, which
    // only ever compares two getBoundingClientRect()s and never writes a
    // pixel value into a style, so it isn't affected the same way.)
    const zoom = parseFloat(window.getComputedStyle(document.body).zoom) || 1;

    const sidebarRect = sidebar.getBoundingClientRect();
    track.style.left = `${(sidebarRect.right - 10) / zoom}px`;
    track.style.height = `${sidebarRect.height / zoom}px`;
    track.style.top = `${sidebarRect.top / zoom}px`;

    const trackHeight = sidebarRect.height;
    const { scrollHeight, clientHeight, scrollTop } = sidebar;
    if (scrollHeight <= clientHeight) {
      thumb.style.display = "none";
      return;
    }
    thumb.style.display = "block";
    const ratio = clientHeight / scrollHeight;
    const thumbHeight = Math.max(30, trackHeight * ratio);
    const maxThumbTop = trackHeight - thumbHeight;
    const scrollRatio = scrollTop / (scrollHeight - clientHeight);
    thumb.style.height = `${thumbHeight / zoom}px`;
    thumb.style.top = `${(maxThumbTop * scrollRatio) / zoom}px`;
  }
  handleThumbMouseDown(e) {
    e.preventDefault();
    this.dragging = true;
    this.dragStartY = e.clientY;
    this.dragStartScrollTop = this.sidebarRef.current.scrollTop;
    document.addEventListener("mousemove", this.handleDragMouseMove);
    document.addEventListener("mouseup", this.handleDragMouseUp);
  }
  handleDragMouseMove(e) {
    if (!this.dragging) return;
    const sidebar = this.sidebarRef.current;
    if (!sidebar) return;
    const trackHeight = sidebar.getBoundingClientRect().height;
    const deltaVisual = e.clientY - this.dragStartY;
    const scale = sidebar.scrollHeight / trackHeight;
    sidebar.scrollTop = this.dragStartScrollTop + deltaVisual * scale;
  }
  handleDragMouseUp() {
    this.dragging = false;
    document.removeEventListener("mousemove", this.handleDragMouseMove);
    document.removeEventListener("mouseup", this.handleDragMouseUp);
  }

  render() {
    var currentPage = this.props.currentPage;
    return (
      <div className="sticky">
        <div className="app-sidebar__overlay" data-bs-toggle="sidebar"></div>
        <div className="app-sidebar" ref={this.sidebarRef}>
          <div className="side-header">
            <a className="header-brand1" href="index.html">
              <img
                src={logo}
                className="header-brand-img desktop-logo"
                alt="logo"
              />
              <img
                src={logo}
                className="header-brand-img toggle-logo"
                alt="logo"
              />
              <img
                src={logo}
                className="header-brand-img light-logo"
                alt="logo"
              />
              <img
                src={logo}
                className="header-brand-img light-logo1"
                alt="logo"
                style={{ width: "130px" }}
              />
            </a>
          </div>
          <div className="main-sidemenu">
            <div className="slide-left disabled" id="slide-left">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#7b8191"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path d="M13.293 6.293 7.586 12l5.707 5.707 1.414-1.414L10.414 12l4.293-4.293z" />
              </svg>
            </div>
            <ul className="side-menu" ref={this.menuContentRef}>
              <li className="sub-category">
                <h3>Main</h3>
              </li>
              {mneuList.map((item, index) => {
                const submenu = (item.submenu ?? []).filter((sItem) => hasPermission(sItem.moduleID, "view"));
                if(hasPermission(item.moduleID, "view") || item.moduleID===0 || submenu.length > 0) {
                  return (
                    <li
                      className={
                        item.active.indexOf(currentPage) >= 0 &&
                        submenu.length > 0
                          ? "slide is-expanded"
                          : "slide"
                      }
                      key={index}
                    >
                      <Link
                        className={`side-menu__item ${
                          submenu.length > 0 ? "has-link" : ""
                        } ${
                          item.active.indexOf(currentPage) >= 0/*  &&
                          submenu.length > 0 */
                            ? " active"
                            : ""
                        }`}
                        data-bs-toggle="slide"
                        to={item.link !== "" ? "/" + item.link : "#"}
                      >
                        <i className={`side-menu__icon ${item.icon}`}></i>
                        <span className="side-menu__label">{item.name}</span>
                        {submenu.length > 0 && (
                          <i className="angle fe fe-chevron-right"></i>
                        )}
                      </Link>
                      {submenu.length > 0 && (
                        <ul className="slide-menu">
                          {submenu.map((sItem, sIndex) => {
                            return (
                              <li
                                className={
                                  currentPage === sItem.active
                                    ? "is-expanded"
                                    : ""
                                }
                                key={sIndex}
                              >
                                <Link
                                  to={`/${sItem.link}`}
                                  className={`slide-item ${
                                    currentPage === sItem.active ? "active" : ""
                                  }`}
                                >
                                  {sItem.name}
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                      )}
                    </li>
                  );
                }
              })}
            </ul>
            <div className="slide-right" id="slide-right">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="#7b8191"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path d="M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z" />
              </svg>
            </div>
          </div>
        </div>
        <div className="custom-sidebar-scrollbar-track" ref={this.trackRef}>
          <div
            className="custom-sidebar-scrollbar-thumb"
            ref={this.thumbRef}
            onMouseDown={this.handleThumbMouseDown}
          ></div>
        </div>
      </div>
    );
  }
}

export default Header;
